import { render } from "./Relations.vue?vue&type=template&id=4417ef14"
import script from "./Relations.vue?vue&type=script&lang=js"
export * from "./Relations.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__